import { render } from "./linbaoList.vue?vue&type=template&id=16bbf4dc"
import script from "./linbaoList.vue?vue&type=script&lang=js"
export * from "./linbaoList.vue?vue&type=script&lang=js"

import "./linbaoList.vue?vue&type=style&index=0&id=16bbf4dc&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__